import { HttpClient } from '@angular/common/http';
import { AuthService } from './../user/auth.service';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { ListMetadata } from '../../models/list-metadata.model';
import { Observable } from 'rxjs/Rx';
import { publishReplay, refCount } from 'rxjs/operators';
import { ListReservation } from 'app/models/loyalty-reservation-search.models';

@Injectable()
export class LoyaltyReservationSearchService {
  baseUrl = HttpClientService.BASE_MS_LOYALTY;
  promoUrl = HttpClientService.BASE_MS_PROMO;

  constructor(
    private http: HttpClientService,
    private authService: AuthService,
    private httpClient: HttpClient
    ) { }

   /**
      * Tramite metodo GET, restituisce la lista delle Reservation.
      * Prevede obbligatoriamente un offset ed un limite, permettendo la paginazione della lista.
    */
    list(
      offset = null,
      limit = null,
      search?: Array<{ key: string, value: string }>,
      globalSearch?: string,
      sort?: string,
      sort_dir?: number
    ): Observable<{ data: Array<ListReservation>, metadata: ListMetadata }> {
      const params = HttpClientService.buildListParams(offset, limit, search, globalSearch, sort, sort_dir);
      return this.http.getPaged(this.baseUrl + `/reservation/getReservationList` +
        (params.toString() ? '?' + params.toString().replace(/\+/gi, '%2B').replace(/'/gi, "''") : '' ));
    }


    /**
     * Chiamata GET per ottenere la lista dei Gift Type
     * @returns
     */
    getGiftType(){
      return this.http.get(`${this.promoUrl}/catalog-gift/type`);
    }

    /**
     * Chiamata GET per ottenere la lista dei Delivery Type
     * @returns
     */
    getDeliveryType(){
      return this.http.get(`${this.baseUrl}/params?param_group=delivery_type`);
    }


    /**
     * chiamata GET per ottenere la lista degli Status Definition
     * @returns
     */
    getStatusDefinition(){
      return this.http.get(`${this.baseUrl}/reservation/gift_status_definition`);
    }

    /**
     * Chiammata a Filtri Extended Search
     */
    sendExtSearchQuery(data): Observable<{ data: any, metadata: ListMetadata }> {
      if (data.sortField && data.sortDir) {
        return this.http.postPaged(`${this.baseUrl}/reservation/getReservationList?offset=${data.offset}&limit=${data.limit}&sort=${data.sortField}&sort_dir=${data.sortDir}`, data.query);
      } else {
        return this.http.postPaged(`${this.baseUrl}/reservation/getReservationList?offset=${data.offset}&limit=${data.limit}`, data.query);
      }
    }

    /******* Export Excel ********/

    getExcelFilename(all: boolean, filters?: any[]) {
      let queryString = all ? 'view=ALL&' : '';
      /* Se di tipo Array, filters corrisponde ai filtri della table e vengono inviati in query string,
         altrimenti ai filtri della ExtSearch, quindi vengono inviati come payload
      */
      let data = Array.isArray(filters) ? {} : filters;
      if (Array.isArray(filters) && filters.length > 0) {
         filters.forEach(filter => queryString += `${filter.key}=${filter.value}&`);
      }
      return this.http.post(queryString.length > 0 ? `${this.baseUrl}/reservation/exportReservations?${queryString}` : `${this.baseUrl}/reservation/exportReservations`, data);
    }

    downloadExcel(filename: string): Observable<Blob> {
      const requestBody = {'filename': filename};
      const userCompany = this.authService.user.selectedCompany.toString();
      const token =  `Bearer ${this.authService.user.token}`;
      const language = this.authService.sessionHelper.selectedLanguage;
      const requestHeaders = {
        'Accept-Company': userCompany,
        'Content-Type': 'application/json',
        'Authorization': token,
        'Accept-Language': language
      };
      return this.httpClient.post(
        '/koncentro-loyalty/download',
        requestBody,
        {
          headers: requestHeaders,
          responseType: 'blob'
        }
      );
    }
}



// WEBPACK FOOTER //
// ./src/app/services/loyalty/loyalty-reservation-search.service.ts